
import gsap from "gsap/dist/gsap";
export default {
  init() {
    
    $('#menu-footer > li.menu-item-has-children').addClass('inactive');


    $('#menu-footer > .inactive > a').on('click', function(e){
      e.preventDefault();
      if($(this).parent().hasClass('active')) { 
        $(this).parent().find('.sub-menu').slideUp();
        $('.active').removeClass('active').addClass('inactive');
      } else {
        $('.active .sub-menu').slideUp();
        $('.active').removeClass('active').addClass('inactive');
        $(this).parent('li').removeClass('inactive').addClass('active').find('> ul').stop(true, true).slideDown('slow'); 
      }
    });

    $('.search-head').on('click', function(){
      $('#search-overlay').fadeIn();
    });

    $('.close-overlay').on('click', function(e){
      e.preventDefault();
      $('#search-overlay').fadeOut();
    });
    

    $('.sub-sub-menu').each(function(){
      var subSubMenuH = $(this).parent('li').parent('ul').outerHeight();
      var subSubMenuW = $(this).parent('li').parent('.sub-menu-head').outerWidth();
      var subSubMenuI = $(this).find('> ul').children('li').length;
      $(this).css({'height' : subSubMenuH, 'width' : 'max-content', 'min-width' : '300px', 'left' : subSubMenuW});
      $(this).parent().parent().css({'height' : subSubMenuH });
      if(subSubMenuI > 6){
        $(this).css({'column-count' : 2, 'column-rule' : '1px solid #0069b4'});
      }
    })

    gsap.set($('.sub-menu-head .has_children:first-child() .sub-sub-menu'), { zIndex: 10});
    gsap.set($('.sub-menu-head .has_children:last-child() .sub-sub-menu'), { zIndex: 1, autoAlpha:0});
    
    // gsap.to($('.s-menu-0 .sub-sub-menu').parent('.has_children').parent('.sub-menu-head'), {x:-500});

    $('#main-navbar > ul > .has_children > a').on('click', function(){
      return false;
    });

    // Main Nav Bar Animation
    gsap.to('.sub-menu-head',{autoAlpha: 0});
    $('#main-navbar > ul > .has_children').hover(function(){
      $('#nav-mask').fadeIn();
      gsap.to($(this).find('> .sub-menu-head').stop(true, true), {autoAlpha: 1, display: 'block', duration: .5});
      
      gsap.to($(this).find('> .sub-menu-head .has_children .sub-sub-menu'), {zIndex : 10, autoAlpha: 0, transformOrigin: 'left', duration: 0});
      gsap.to($(this).find('> .sub-menu-head .has_children:first-child() .sub-sub-menu'), {zIndex : 10, autoAlpha: 1, transformOrigin: 'left', duration: 0});
      if(!$(this).hasClass("menu-item-303")) { 
        $(this).find('> .sub-menu-head .head-desc a').first().addClass('active');
      }
    }, function(){
      $('#nav-mask').stop(true,true).fadeOut();
      gsap.to($(this).find('> .sub-menu-head').stop(true, true), {autoAlpha: 0, display: 'none', duration: .5});
      gsap.to($(this).find('> .sub-menu-head .has_children:first-child() .sub-sub-menu'), {zIndex : 10, autoAlpha: 1, transformOrigin: 'left', duration: 0});
      gsap.to($(this).find('.sub-menu-head'), {x:0, duration: 0});
    });

    gsap.set('.sub-sub-menu', { autoAlpha: 0});

    $('.sub-menu-head .has_children .head-desc a').click(function(){
      $('.sub-menu-head .head-desc a.active').removeClass('active');
      if(!$(this).parent().parent().hasClass("menu-item-303")) { 
        $(this).addClass('active');
      }
      //gsap.to($(this).parent('.sub-menu-head'), {x:0, duration: .5});
      gsap.to($('.sub-menu-head .has_children .sub-sub-menu').stop(true, true), {zIndex : '-=10', autoAlpha:0, duration: 0});
      gsap.to($(this).parent().parent().parent('.sub-menu-head'), {x:-320, duration: .5});
      gsap.to($(this).parent().parent().find(' > .sub-sub-menu').stop(true, true), {zIndex : '+=10', transformOrigin: 'left', autoAlpha: 1, duration: 0});
      return false;
    });

    /*gsap.set($('.item-1442, .item-1480').find(' > .sub-sub-menu').stop(true, true), {autoAlpha: 0});

    $('.item-1442, .item-1480').hover(function(){
      gsap.to($(this).find(' > .sub-sub-menu').stop(true, true) , {autoAlpha: 1});
    }, function(){
      gsap.to($('.item-1442, .item-1480').find(' > .sub-sub-menu').stop(true, true) , {autoAlpha: 0, duration: 0.1});
    });*/

    $('#mobile-navigation .sub-menu-head').hide();

    $('#mobile-navigation .menu-item-has-children a').on('click', function(e){
      e.preventDefault();
      $(this).find('+ .sub-menu-head').slideToggle();
    });

    $('.navbar-trigger').on('click', function(e){
      e.preventDefault();
      $('#mobile-navigation').slideToggle();
    });

    $('#menu-mobile-main a').on('click', function(e){
      e.preventDefault();
      var target = $(this).attr('href');
      console.log(target);
      $(target).animate({
        'left' : '0'
      });
    });

    $('.back-btn').on('click', function(e){
      e.preventDefault();
      $(this).closest('.navbar-menu-sub-mobile').animate({
        'left' : '100vw'
      });
    });

    
    gsap.to('.menu-sub-mobile .sub-menu', {x: $(window).width() });

    $('.menu-sub-mobile .sub-menu-ul > li:first-child()').prepend('<li class="skyblue"><a href="#" class="third-back-btn"><i class="fas fa-chevron-left"></i> Go Back</a></li>')
  
    $('.menu-sub-mobile .menu-item-has-children > a').on('click', function(e){
      e.preventDefault();
      gsap.to('.menu-sub-mobile', {x: '-' + $(window).width() });
    });

    $('.third-back-btn').on('click', function(e){
      e.preventDefault();
      gsap.to('.menu-sub-mobile', {x: 0 });
    });
  },
  finalize() {}
}